import { get, post, patch, deleteRequest } from 'utils/api';

export const getWhatsNew = (data) => {
  return get(`/whatsNew`, data);
};

export const getWhatsNewById = (id) => {
  return get(`/whatsNew/${id}`);
};

export const addWhatsNew = (data) => {
  return post(`/whatsNew`, data);
};

export const updateWhatsNew = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/whatsNew/${id}`, data);
};

export const deleteWhatsNew = (id) => {
  return deleteRequest(`/whatsNew/${id}`);
};

export const whatsNew = {
  getWhatsNew,
  getWhatsNewById,
  addWhatsNew,
  updateWhatsNew,
  deleteWhatsNew,
};
